import enviroment from "../enviroments";

// Caso seja o ambiente de pre-prod a arquitetura muda ( somente o prefixo ), no contexto de backoffice.
const backofficeEnviroment =
  enviroment.URL_ADMIN === "https://sellit-app-web-pre-prod.azurewebsites.net"
    ? "backoffice-pre-prod"
    : "backoffice";

export default backofficeEnviroment;
